import React from "react";

import PropType from "prop-types";

const SearchContext = React.createContext();

export function SearchProvider({ children }) {
  const [search, setSearch] = React.useState("");
  const [searchDecorator, setSearchDecorator] = React.useState(null);

  const value = React.useMemo(
    () => ({
      search,
      searchDecorator,
      setSearch,
      setSearchDecorator,
    }),
    [search, searchDecorator]
  );

  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
}

export default SearchContext;

SearchProvider.propTypes = {
  children: PropType.node.isRequired,
};
